// extracted by mini-css-extract-plugin
export var buttons = "_at-0";
export var buttonsActive = "_at-h";
export var cancelConfirm = "_at-1";
export var closeButton = "_at-2";
export var column = "_at-3";
export var container = "_at-4";
export var detailHeader = "_at-6";
export var detailTitle = "_at-7";
export var detailsContent = "_at-5";
export var header = "_at-8";
export var headerWithClose = "_at-9";
export var icon = "_at-a";
export var infoIcon = "_at-c";
export var informationContainer = "_at-b";
export var sideDrawer = "_at-d";
export var sideDrawerOpen = "_at-e";
export var stickyFooter = "_at-f";
export var typeOption = "_at-g";